import React from 'react';
import {Box, Sheet, Stack} from '@mui/joy';
import Description from "./Description";
import Photo from "./Photo";
import ContactInfo from "./ContactInfo";
import {SummaryModel} from "../model/summary";


export interface TypeProfile{
summary: SummaryModel;
    resumeURL: string;
    profileLight: string;
    profileDark: string;
}
function Profile( {summary, resumeURL, profileLight, profileDark} : TypeProfile) {
    return (
        <Sheet sx={{paddingY: 2}}>
            <Stack justifyContent={{md: "", xs: "center"}}
                   alignItems={{md: "center", xs: "center"}} sx={{padding: 0}} direction={{xs: 'column', md: 'row'}}
                   spacing={{xs: 2, sm: 2, md: 0}}>
                <Box padding={{xs: 0, md: 0}} display={{xs: 'block', md: 'none'}}>
                    <Photo profileLight={profileLight} profileDark={profileDark} animate={true} useAvatar={false}/>
                </Box>
                <Stack alignItems={{md: "start", xs: "center"}} sx={{padding: 0}} direction='column' spacing={{xs: 2, sm: 2, md: 4}}>
                    <Description summary={summary} resumeURL = { resumeURL }/>
                    <ContactInfo summary={summary}/>
                </Stack>
                    <Stack width={16}/>
                <Box padding={{xs: 0, md: 0}} display={{xs: 'none', md: 'block'}}>
                    <Photo profileLight={profileLight} profileDark={profileDark} animate={true} useAvatar={false}/>
                </Box>
            </Stack>
        </Sheet>
    );
}

export default Profile;